import { useCallback, useContext, useEffect, useRef, useState } from "react";
import Menu from "../Menu";
import { Dimensions } from "react-native";
import StyleSheetRW from "core/StyleSheetRW";
import { db } from "@react-native-firebase/database";
import { get, onValue, ref, update } from "firebase/database";
import { formatDate, } from "src/utils/Date&TimeUtils";
import Dialog from "src/components/Dialog";
import { Modal } from "react-native";
import { View } from "react-native";
import { ScrollView } from "react-native";
import { Text } from "react-native";
import { TextInput } from "react-native";
import Loader from "src/components/Loader";
import { LEAVE_STATUS, LEAVE_TYPE, MOBILE_VIEW_WIDTH } from "res/constants";
import { NotificationContext } from "src/context/NotificationContext";
import DropDownField from "src/components/DropDownField";
import DateField from "src/components/DateField";


const AdminTimeOffScreen = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [recordEntryDate, setRecordEntryDate] = useState("");
    const [recordEntryObj, setRecordEntryObj] = useState<any>(null);
    const screenWidth = Dimensions.get('window').width;
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [rejectReason, setRejectReason] = useState("");
    const [userId, setUserId] = useState("")
    const tableHeadstyle = { ...styles.tableHead, display: screenWidth < 600 ? 'none' : 'table-cell' };
    const tableDataStyle = { ...styles.tableData1, display: screenWidth < 600 ? 'none' : 'table-cell' }
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [dropdownPosition, setDropdownPosition] = useState({ x: 0, y: 0, visible: false });
    const [showToast2, setShowToast2] = useState(false);
    const [newlyAddedUid, setNewlyAddedUid] = useState<string | null>(null);
    const [previousUid, setPreviousUid] = useState<string | null>(null);
    const { notificationClicked, setNotificationClicked } = useContext(NotificationContext)
    const [filters, setFilters] = useState({
        employeeName: '',
        leaveType: 'All',
        startDate: '',
        endDate: '',
        status: 'All'
    });

    const filtersContainerStyle = { ...styles.filtersContainer, flexDirection: screenWidth <= MOBILE_VIEW_WIDTH ? 'column' : 'row' }
    const filterSpecialInputStyle = { ...styles.filterSpecialInput, marginTop: screenWidth <= MOBILE_VIEW_WIDTH ? 25 : undefined }
    const filterTable = { ...styles.tableStyle, marginTop: screenWidth <= MOBILE_VIEW_WIDTH ? 50 : 25 }

    const handleFilterChange = (filterName, value) => {
        console.log(filterName, value);

        setFilters({ ...filters, [filterName]: value });
    };


    useEffect(() => {
        setShowLoader(true);
        const dbRef = ref(db, 'timeOffRequest');
        const fetchRequestUpdatedData = onValue(dbRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const allTimeOffLists: any = [];
                let newUid: any = null;
                Object.keys(data).forEach((userUID) => {
                    const userData = data[userUID];
                    const userTimeOffLists: any = [];
                    Object.keys(userData).forEach((requestDate) => {
                        const recordArray = Object.keys(userData[requestDate]).map((requestUid) => {
                            const { startDate, endDate, availability, reason, status, name, leaveType, totalhours } = userData[requestDate][requestUid];
                            if (!newUid || requestUid > newUid) {
                                newUid = requestUid;
                            }

                            return { startDate, endDate, availability, reason, status, name, uid: requestUid, leaveType, totalhours };
                        });
                        userTimeOffLists.push({ date: requestDate, timeOffLists: recordArray });
                    });
                    allTimeOffLists.push({ userUID, userData: userTimeOffLists });
                });
                console.log(allTimeOffLists);

                setTableData(allTimeOffLists);
                if (previousUid !== newUid) {
                    setNewlyAddedUid(newUid);
                }
                setPreviousUid(newUid)

                newUid = null
                setShowLoader(false);
            } else {
                setShowLoader(false);
                console.log("No data available");
            }
        }, (error) => {
            setShowLoader(false);
            console.error("Failed to retrieve data:", error);
        });

        return () => {
            fetchRequestUpdatedData();
        };
    }, []);



    useEffect(() => {
        if (notificationClicked) {
            const element = document.getElementById(newlyAddedUid);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "center" });
                element.style.backgroundColor = "rgba(0, 0, 255, 0.2)";
                setTimeout(() => {
                    element.style.backgroundColor = "";
                    setNewlyAddedUid(null);
                }, 5000);
                setNotificationClicked(false)
            }
        }
    }, [newlyAddedUid, notificationClicked]);

    const [selectedRow, setSelectedRow] = useState<any>("");
    const handleRowClick = useCallback((event: any, entry: any, date: any, userID: string) => {
        event.preventDefault();
        const container = scrollContainerRef.current;
        if (container) {
            const containerRect = container.getBoundingClientRect();
            const x = Math.min(event.clientX, containerRect.right - 150);
            const y = Math.min(event.clientY, containerRect.bottom - 70); 
            setDropdownPosition({ x, y, visible: true });
        }
        setRecordEntryDate(date)
        setRecordEntryObj(entry)
        setUserId(userID)
        setSelectedRow(entry === selectedRow ? "" : entry);

    }, [selectedRow]);
    const handleApproveEntry = async () => {
        setShowLoader(true)
        try {
            if (recordEntryObj !== null && userId !== "") {
                const dbRef = ref(db, `timeOffRequest/${userId}/${recordEntryDate}/${recordEntryObj.uid}`);
                const { uid, ...dataWithoutUid } = recordEntryObj;
                const newData = { ...dataWithoutUid, status: "Approved" };
                await update(dbRef, newData)
                    .then(() => {
                        setShowLoader(false)
                        setSelectedRow("")
                        // fetchTimeOffList();
                    })
                    .catch((error) => {
                        setShowLoader(false)
                        setSelectedRow("")
                        setToastMessage("Failed to update entry status")
                        setShowToast(true)
                    });
            }
        } catch (error) {
            setShowLoader(false)
            console.error("Error updating entry status: ", error);
        }
    };
    const handleRejectEntry = async () => {
        setShowLoader(true)
        try {
            if (recordEntryObj !== null && userId !== "") {
                const dbRef = ref(db, `timeOffRequest/${userId}/${recordEntryDate}/${recordEntryObj.uid}`);
                const { uid, ...dataWithoutUid } = recordEntryObj;
                const newData = { ...dataWithoutUid, status: "Rejected", rejectReason: rejectReason };
                await update(dbRef, newData)
                    .then(() => {
                        setShowLoader(false)
                        setSelectedRow("")
                        // fetchTimeOffList();
                    })
                    .catch((error) => {
                        setShowLoader(false)
                        setSelectedRow("")
                        setToastMessage("Failed to update entry status")
                        setShowToast(true)
                    });
            }
        } catch (error) {
            setShowLoader(false)
            console.error("Error updating entry status: ", error);
        }
    };

    useEffect(() => {
        const scrollContainer = scrollContainerRef?.current;

        const handleSelectedRow = () => {
            setSelectedRow("");
        };

        const handletouchmove = () => {
            setSelectedRow("");
        };

        const handleClick = () => {
            const isMobile = window.innerWidth < MOBILE_VIEW_WIDTH;
            if (!isMobile) {
                setSelectedRow("");
            }
        };

        if ('ontouchstart' in window) {
            document.body.addEventListener('touchmove', handletouchmove);
        } else {
            document.body.addEventListener('click', handleClick);
        }

        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleSelectedRow);
        }

        return () => {
            if ('ontouchstart' in window) {
                document.body.removeEventListener('touchmove', handletouchmove);
            } else {
                document.body.removeEventListener('click', handleClick);
            }
            if (scrollContainer) {
                scrollContainer.removeEventListener("scroll", handleSelectedRow);
            }
        };
    }, []);

    const filteredSortedUserData = tableData.map((userData:any) => {
        const filteredUserData = userData.userData.map((timeOffList:any) => {
            const filteredTimeOffLists = timeOffList.timeOffLists.filter((record:any) => {
                const isNameMatch = filters.employeeName === '' || record.name.toLowerCase().includes(filters.employeeName.toLowerCase());
                const isLeaveTypeMatch = filters.leaveType === 'All' || record.leaveType === filters.leaveType;
                const isStatusMatch = filters.status === 'All' || record.status === filters.status;
                const startDate = new Date(record.startDate);
                const endDate = new Date(record.endDate);
                const filterStartDate = filters.startDate ? new Date(filters.startDate) : null;
                const filterEndDate = filters.endDate ? new Date(filters.endDate) : null;
                const isDateMatch = (!filterStartDate || startDate >= filterStartDate) &&
                    (!filterEndDate || endDate <= filterEndDate);

                return isNameMatch && isLeaveTypeMatch && isStatusMatch && isDateMatch;
            });

            const sortedTimeOffLists = filteredTimeOffLists.sort((a: any, b: any) => {
                const dateA = new Date(a.startDate);
                const dateB = new Date(b.startDate);
                return dateB.getTime() - dateA.getTime();
            });


            return { date: timeOffList.date, timeOffLists: sortedTimeOffLists };
        });

        return { userUID: userData.userUID, userData: filteredUserData };
    });






    return (
        <div style={{ display: "flex", flexDirection: "row", height: "100%", maxHeight: '100%' }}>
            <Menu />
            {showToast2 && (
                <Dialog
                    message={toastMessage}
                    onDialogClose={() => setShowToast2(false)}
                    isDialogVisible={showToast2}
                    title="Reason"
                />)}
            <div ref={scrollContainerRef} style={{ ...styles.container, overflowX: "hidden" }}>
                <div style={{ width: screenWidth < 600 ? "90%" : "100%", padding: '0px 0px 0px 20px', height: "100%" }}>
                    <div style={{ width: screenWidth < 600 ? "100%" : "97%", fontFamily: "Outfit", }}>
                        <div style={{ width: "100%" }}>
                            <h1 style={styles.heading}>Leave Requests</h1>
                        </div>
                    </div>
                    <div style={styles.tableContainer}>
                        <span style={styles.tableSpanHeading}>Applied Leaves</span>
                        <table style={styles.tableStyle}>
                            <thead >
                                <tr style={{ backgroundColor: '#2F4858', color: '#FFFFFF' }}>
                                    <th style={styles.tableHead}>Employee Name</th>
                                    <th style={tableHeadstyle}>Leave Type</th>
                                    <th style={styles.tableHead}>Applied On</th>
                                    <th style={tableHeadstyle}>Unavailability</th>
                                    <th style={tableHeadstyle}>Date</th>
                                    <th style={tableHeadstyle}>Day</th>

                                    <th style={styles.tableHead}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((userData: any) => (
                                    userData.userData.map((timeOffList: any) => (
                                        timeOffList.timeOffLists.filter((entry: any) => entry.status === "Applied").map((record: any, index: any) => (
                                            <tr id={record.uid} key={record.uid} style={{
                                                backgroundColor: record.uid === selectedRow.uid ? '#0000FF33' : index % 2 === 0 ? '#2F48581A' : '#D8E6DC',
                                                cursor: 'pointer',

                                            }}
                                                onContextMenu={(e) => { handleRowClick(e, record, timeOffList.date, userData.userUID) }}
                                                onClick={screenWidth <= MOBILE_VIEW_WIDTH ? (e) => handleRowClick(e, record, timeOffList.date, userData.userUID) : undefined}>
                                                <td style={{ padding: "15px" }}>{record.name}</td>
                                                <td style={tableDataStyle}>{record.leaveType || ""}</td>
                                                <td style={styles.tableData1}>{formatDate(timeOffList.date, "DD MMM, YY")}</td>
                                                <td style={tableDataStyle}>{record.availability === "Specify hours" ? `${record.totalhours} hrs` : record.availability}</td>
                                                <td style={tableDataStyle}>{formatDate(record.startDate, "DD MMM, YY") === formatDate(record.endDate, "DD MMM, YY") ? formatDate(record.startDate, "DD MMM, YY") : `${formatDate(record.startDate, "DD MMM, YY")} - ${formatDate(record.endDate, "DD MMM, YY")}`}</td>
                                                <td style={tableDataStyle}>{formatDate(record.startDate, "DD MMM, YY") !== formatDate(record.endDate, "DD MMM, YY") ? `${formatDate(record.startDate, "dddd")}...` : formatDate(record.startDate, "dddd")}</td>

                                                <td style={styles.tableData1}>{record.status}</td>
                                                {record.uid === selectedRow.uid && (
                                                    <div style={{ position: 'fixed', top: dropdownPosition.y, left: dropdownPosition.x, zIndex: 9999 }}>
                                                        <table style={{ width: '96px', height: '61px', borderRadius: '12px', backgroundColor: "#FFFFFF", borderCollapse: 'collapse' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ display: 'flex', justifyContent: "center", alignItems: "left", flexDirection: "column", gap: "8px", padding: "8px" }}>
                                                                        <span onClick={handleApproveEntry} style={styles.DropDownspan}>Approve</span>
                                                                        <span onClick={() => setIsVisible(true)} style={{ ...styles.DropDownspan, }} >Reject</span>
                                                                        <span onClick={() => { setShowToast2(true); setToastMessage(record.reason) }} style={{ ...styles.DropDownspan, }} >View Reason</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </tr>
                                        ))
                                    ))
                                ))}
                            </tbody>
                        </table>
                        <span style={styles.tableSpanHeading}>Approved / Rejected Leaves</span>
                        <div style={filtersContainerStyle}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <label htmlFor="employeeName" style={styles.label}>Search Employees</label>
                                <input
                                    type="text"
                                    placeholder="Search by Employee Name"
                                    value={filters.employeeName}
                                    onChange={(e) => handleFilterChange('employeeName', e.target.value)}
                                    style={styles.filterInput}
                                    name="employeeName"
                                    id="employeeName"
                                />
                            </div>
                            <div style={{ ...filterSpecialInputStyle, marginTop: screenWidth <= MOBILE_VIEW_WIDTH ? 5 : undefined }}>
                                <label htmlFor="leaveType" style={styles.label}>Leave Type</label>
                                <DropDownField
                                    value={filters.leaveType}
                                    placeholder="All Leave Types"
                                    bodyStyle={{ marginHorizontal: 0 }}
                                    options={LEAVE_TYPE}
                                    onChangeText={(text) => handleFilterChange('leaveType', text)}
                                    isCloseOnSelection={true}
                                />
                            </div>
                            <div style={filterSpecialInputStyle}>
                                <label htmlFor="startDate" style={styles.label}>Start Date</label>
                                <DateField
                                    value={filters.startDate}
                                    placeholder="MM-DD-YYYY"
                                    onChangeText={(text) => handleFilterChange("startDate", text)}                                />
                            </div>
                            <div style={filterSpecialInputStyle}>
                                <label htmlFor="endDate" style={styles.label}>End Date</label>
                                <DateField
                                    value={filters.endDate}
                                    placeholder="MM-DD-YYYY"
                                    onChangeText={(text) => handleFilterChange("endDate", text)}
                                />
                            </div>
                            <div style={filterSpecialInputStyle}>
                                <label htmlFor="status" style={styles.label}>Status Type</label>
                                <DropDownField
                                    value={filters.status}
                                    placeholder="Please Select a City"
                                    bodyStyle={{ marginHorizontal: 0 }}
                                    options={LEAVE_STATUS}
                                    onChangeText={(text) => handleFilterChange('status', text)}
                                    isCloseOnSelection={true}
                                />
                            </div>
                        </div>
                        <table style={filterTable}>
                            <thead>
                                <tr style={{ backgroundColor: '#2F4858', color: '#FFFFFF' }}>
                                    <th style={styles.tableHead}>Employee Name</th>
                                    <th style={tableHeadstyle}>Leave Type</th>
                                    <th style={styles.tableHead}>Applied On</th>
                                    <th style={tableHeadstyle}>Unavailability</th>
                                    <th style={tableHeadstyle}>Date</th>
                                    <th style={tableHeadstyle}>Day</th>
                                    <th style={styles.tableHead}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSortedUserData.map((userData) =>
                                    userData.userData.map((timeOffList:any) =>
                                        timeOffList.timeOffLists.filter((entry: any) => entry.status === "Approved" || entry.status === "Rejected").map((record:any, index:any) => (
                                            <tr id={record.uid} key={record.uid} style={{
                                                backgroundColor: record.uid === selectedRow.uid ? '#0000FF33' : index % 2 === 0 ? '#2F48581A' : '#D8E6DC',
                                                cursor: 'pointer',
                                            }}
                                                onContextMenu={(e) => { handleRowClick(e, record, timeOffList.date, userData.userUID) }}
                                                onClick={screenWidth <= MOBILE_VIEW_WIDTH ? (e) => handleRowClick(e, record, timeOffList.date, userData.userUID) : undefined}>
                                                <td style={{ padding: "15px" }}>{record.name}</td>
                                                <td style={tableDataStyle}>{record.leaveType || ""}</td>
                                                <td style={styles.tableData1}>{formatDate(timeOffList.date, "DD MMM, YY")}</td>
                                                <td style={tableDataStyle}>{record.availability === "Specify hours" ? `${record.totalhours} hrs` : record.availability}</td>
                                                <td style={tableDataStyle}>{formatDate(record.startDate, "DD MMM, YY") === formatDate(record.endDate, "DD MMM, YY") ? formatDate(record.startDate, "DD MMM, YY") : `${formatDate(record.startDate, "DD MMM, YY")} - ${formatDate(record.endDate, "DD MMM, YY")}`}</td>
                                                <td style={tableDataStyle}>{formatDate(record.startDate, "DD MMM, YY") !== formatDate(record.endDate, "DD MMM, YY") ? `${formatDate(record.startDate, "dddd")}...` : formatDate(record.startDate, "dddd")}</td>
                                                <td style={styles.tableData1}>{record.status}</td>
                                                {record.uid === selectedRow.uid && (
                                                    <div style={{ position: 'fixed', top: dropdownPosition.y, left: dropdownPosition.x, zIndex: 9999 }}>
                                                        <table style={{ width: '96px', height: '61px', borderRadius: '12px', backgroundColor: "#FFFFFF", borderCollapse: 'collapse' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ display: 'flex', justifyContent: "center", alignItems: "left", flexDirection: "column", gap: "8px", padding: "8px" }}>
                                                                        <span onClick={handleApproveEntry} style={styles.DropDownspan}>Approve</span>
                                                                        <span onClick={() => setIsVisible(true)} style={{ ...styles.DropDownspan, }} >Reject</span>
                                                                        <span onClick={() => { setShowToast2(true); setToastMessage(record.reason) }} style={{ ...styles.DropDownspan, }} >View Reason</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </tr>
                                        ))
                                    )
                                )}
                            </tbody>
                        </table>
                        {showToast && (
                            <Dialog
                                message={toastMessage}
                                onDialogClose={() => setShowToast(false)}

                                isDialogVisible={showToast}
                            />
                        )}
                    </div>

                </div>
                <Modal animationType="fade" transparent={true} visible={isVisible}>
                    <View style={{ flex: 1, width: "100%", height: "100%" }}>
                        <ScrollView style={styles.Container}>
                            <View
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                }}
                            >
                                <Text style={styles.heading2}>Reject</Text>
                                <svg
                                    onClick={() => setIsVisible(false)}
                                    style={{ right: 10, position: "absolute", top: 5 }}
                                    width="13"
                                    height="13"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7.6488 6.5L12.762 1.38741C13.0793 1.07001 13.0793 0.555414 12.762 0.238046C12.4446 -0.0793487 11.93 -0.0793487 11.6126 0.238046L6.49998 5.35115L1.38741 0.238046C1.07001 -0.0793487 0.555417 -0.0793487 0.238046 0.238046C-0.0793233 0.555441 -0.0793487 1.07004 0.238046 1.38741L5.35116 6.5L0.238046 11.6126C-0.0793487 11.93 -0.0793487 12.4446 0.238046 12.7619C0.555439 13.0793 1.07004 13.0794 1.38741 12.7619L6.49998 7.64882L11.6126 12.7619C11.93 13.0794 12.4446 13.0794 12.7619 12.7619C13.0793 12.4445 13.0793 11.9299 12.7619 11.6126L7.6488 6.5Z"
                                        fill="#2F4858"
                                    />
                                </svg>
                            </View>

                            <Text style={[styles.label, { marginTop: 0 }]}>Reason</Text>
                            <TextInput
                                style={styles.input}
                                placeholder="Enter reason"
                                placeholderTextColor={"#333333"}
                                onChangeText={(text) => setRejectReason(text)}
                            />

                            <button
                                onClick={() => {
                                    handleRejectEntry();
                                    setIsVisible(false)
                                }}
                                style={{ ...styles.button2, width: "110px", marginTop: 50, cursor: "pointer" }}
                            >
                                Reject
                            </button>

                        </ScrollView>
                    </View>
                </Modal>
                {showLoader && (
                    <Loader />
                )}
            </div>

        </div>

    )
}

const styles = StyleSheetRW.create(() => ({
    container: {
        flex: 1,
        width: "100%",
        height: "100%",
        overflow: "scroll"
    },
    heading: { fontWeight: 'bold', fontSize: 32, color: '#2F4858', marginTop: 20 },
    button: {
        backgroundColor: '#2F4858',
        padding: "10px 30px",
        borderRadius: 100,
        color: 'white',
        fontWeight: "300",
        textAlign: "center",
        borderWidth: 0,
    },
    tableHeading: { fontSize: 20, fontWeight: 'bold', marginBottom: '10px' },
    tableHead: { padding: '15px', textAlign: 'left', borderBottom: '1px solid #2F4858', fontWeight: '300' },
    tableStyle: { width: "100%", borderCollapse: 'collapse', backgroundColor: '#FFFFFF66', height: "100%", marginTop: 20 },
    tableData1: { padding: '15px', borderLeft: '1px solid #2F485880' },
    DropDownspan: { fontFamily: "Outfit", fontSize: 14, fontWeight: "300", textAlign: "left", color: "#2F4858", cursor: "pointer", },
    Container: {
        position: "absolute",
        top: "20%",
        bottom: "40%",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ffffff",
        borderRadius: 24,
        opacity: 1,
        transition: "opacity 0.3s ease",
        zIndex: 1,
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
        width: "299px",
        alignSelf: "center",
    },
    heading2: {
        fontFamily: "Outfit",
        fontSize: 20,
        fontWeight: "bold",
        textAlign: "center",
        color: "#333333",
    },
    tableSpanHeading: {
        fontFamily: "Outfit",
        fontSize: 20,
        fontWeight: "bold",
        color: "#333333",
        marginBottom: "20px",
        marginTop: "20px",
        display: "block"
    },
    label: {
        fontFamily: "Outfit",
        fontSize: 14,
        fontWeight: "600",
        textAlign: "left",
        color: "#333333",
    },
    input: {
        height: 50,
        borderRadius: 10,
        paddingHorizontal: 10,
        backgroundColor: "#0000000D",
        marginTop: 3,
    },
    button2: {
        backgroundColor: "#2F4858",
        alignSelf: "center",
        borderRadius: 100,
        color: "white",
        fontWeight: "300",
        textAlign: "center",
        borderWidth: 0,
        width: "250px",
        height: "38px",
    },
    buttoneStyle: {
        backgroundColor: "#8c9ea2",
        borderRadius: 99,
        fontWeight: "lighter",
        fontSize: "14px",
        color: "white",
        width: "110px",
        height: "37px",
        border: "0",
    },
    tableContainer: { width: "97%", fontFamily: "Outfit", marginTop: "30px", marginBottom: 30 },
    filtersContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '20px',
        flexWrap: "wrap"
    },
    filterInput: {
        fontFamily: "Outfit",
        borderTopRightRadius: 10,
        height: 50,
        outline: "none",
        borderRadius: 10,
        paddingLeft: 10,
        marginTop: 5,
        borderStyle: "none",
        backgroundColor: "#0000000D",
    },
    filterSpecialInput: {
        fontFamily: "Outfit",
        borderTopRightRadius: 10,
        height: 50,
        outline: "none",
        borderRadius: 10,
        borderStyle: "none",
    },
}))

export default AdminTimeOffScreen